import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { ORGS } from './orgs';


import handleChange, { useFormState } from './utils/handleChange';

import SubscriberInfo from './formsParts/SubscriberInfo';

//Individual Form Parts I-II//
import IndRegD from './formsParts/indRegMatters';
import MiscellaneousMatters from './formsParts/indMiscMatters';

//Entity Form Parts I-II//
import EntityRegulationMatters from './formsParts/entityRegMatters';
import EntityMiscMatters from './formsParts/entityMiscMatters';

import BankForm from './formsParts/bankingInfo';
import EntityBankForm from './formsParts/entityBankingInfo';

import { handleSubmit } from './submit';
import { SignaturePad } from './signature';
import { SignaturePadSpouse } from './signatureSpouse'
import { SignaturePadEntity } from './signatureEntity';
import { useNavigate } from 'react-router-dom';

function RealEstateSPV_LLC() {
    const defaultFormData = {
        fundName: "",
        subscriberName: "",
        subscriberName1: "",
        subscriberName2: "",
        authorizedName: "",
        authorizedNameEntity: "",
        title: "",
        titleEntity: "",
        selectedDate: "",
        selectedDateEntity: "",
        amount: "",
        formattedAmount: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        attention: "",
        email: "",
        phone: "",
        otherAddress: "",
        otherAddress2: "",
        otherCity: "",
        otherState: "",
        otherZip: "",
        otherAttention: "",
        otherPhone: "",
        otherEmail: "",
        rows: [
          {
            contactName: "",
            contactPhone: "",
            contactEmail: "",
            contactAddress1: "",
            contactAddress2: "",
            contactAddress3: "",
            contactNotices: "",
            contactCorrespondence: "",
            contactTaxInfo: "",
            contactLegalDocs: ""
          }
        ],
        accreditedInvestorStatus: {
            netWorth: "",
            income: "",
            executive: "",
            securitiesLicense: "",
            knowledgeableEmployee: "",
            familyClient: "",
        },
        investmentAdvisers: {
            netWorth2: "",
            highCommit: "",
            qualPurchaser: "",
        },
        qualifiedPurchaser: {
            ownsFiveMil: "",
        },
        miscMatters: {
            subject4975: "", 
            iraDecisionSPV: "",
            nonUsMemberStatus: "",
            representType: "",
            jointTenancyType: "",
            grantorTrustSettlor1: "",
            grantorTrustSettlor2: "",
            selfRetirementInd: "",
        },
        entityAccreditedInvestor: {
            bankLoan: "",
            brokerDealer: "",
            registeredAdviser: "",
            exemptAdviser: "",
            insuranceCompany: "",
            investmentCompany: "",
            businessDevelopment: "",
            smallBusiness: "",
            statePlan: "",
            erisaFiduciary: "",
            erisaAssets: "",
            erisaSelfDirected: "",
            privateBusinessDevCompany: "",
            corporationLLC: "",
            nonProfitOrg: "",
            businessTrust: "",
            trust5000000: "",
            entity5000000: "",
            familyOfficeEnt: "",
            familyClientEnt: "",
            entityAllAccredited: "",
        },
        entityDisqualifyingEvent: "",
        entityInvestmentCompany: {
            ivestOrBusiness: "",
            investmentCompany: "",
            lessThanTenPercent: "",
            notFormedForFund: "",
            lessThanFortyPercentAssets: "",
            priorInvestments: "",
            governingDocuments: "",
            collectiveInvestment: "",
            beneficialOwners: "",
        },
        entityMiscMatters: {
            notBenefitPlanInvestor: "",
            isRetirementPlan: "",
            iraOwnerDecision: "",
            hasPlanAssets: "",
            isEntityetc: "",
            maxBenefitPlanPercentage: "",
            taxExemptMember: "",
            nonUSMember: "",
            corporation: "",
            generalPartnership: "",
            limitedPartnership: "",
            limitedLiabilityCompany: "",
            governmentEntity: "",
            trustType: "",
            trustName: "",
            otherEntity: "",
            jurisdiction: "",
            domicile: "",
            orgType: "",
            governmentPlans: "",
            foiaSubject: "",
        },
        exceptedInvestmentCompany: "",
        country: "",
        signature: "",
        signatureEntity: "",
        signatureEntityInd: "",
        signatureSpouse: "",
        submissionMessage: "",
        disqualifyingEvent: "",
        selectedCountry: "",
        domicileSelectedCity: "",
        domicileSelectedState: "",
        formAgreementChecked: "",
        entityFormAgreementChecked: "",
        bankName: '',
        bankLocation: '',
        abaRoutingNumber: '',
        swiftCode: '',
        accountName: '',
        accountNumber: '',
        reference: '',
        entityBankName: '',
        entityBankLocation: '',
        entityAbaRoutingNumber: '',
        entitySwiftCode: '',
        entityAccountName: '',
        entityAccountNumber: '',
        entityReference: ''
      };
      
    const navigate = useNavigate();
        const { getAccessTokenSilently, isAuthenticated, loginWithRedirect } = useAuth0();
          
        const [formData, setFormData] = useState(defaultFormData);
        const [fieldErrors, setFieldErrors] = useState({});
        const [submissionMessage, setSubmissionMessage] = useState("");
    
        const today = new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        
        const investorType = formData.investorType;
        const isIndividual = formData.investorType === 'individual';
        const isJointSpouse = formData.investorType === 'jointSpouse';
        const isSelfDirectedIRA = formData.investorType === 'selfDirectedIRA';
        const isRevocableGrantorTrust = formData.investorType === 'revocableGrantorTrust';
        const isEntity = formData.investorType === 'entity';
    
        const [showError, setShowError] = useState(false);
    
        useEffect(() => {
            if (investorType === "entity" && fieldErrors?.entityAccreditedInvestor) {
              const el = document.getElementById("entityAccreditedInvestorScrollAnchor");
              if (el) {
                requestAnimationFrame(() => {
                  el.scrollIntoView({ behavior: "smooth", block: "center" });
                  el.focus({ preventScroll: true });
                });
              } else {
                console.warn("🚫 Scroll anchor not found for entityAccreditedInvestor");
              }
            }
          }, [investorType, fieldErrors?.entityAccreditedInvestor]);    

          
          const onFormSubmit = async (event) => {
            if (!isAuthenticated) {
                await loginWithRedirect({
                authorizationParams: {
                    connection: "email" // Passwordless Email connection name
                }
                });
            return;
            }

             // ✅ Load org ID from localStorage
            const selectedOrgId = localStorage.getItem("selectedOrgId");
            if (!selectedOrgId) {
                console.warn("⚠️ No organization selected — default template will be used.");
            }

            const token = await getAccessTokenSilently();
            const result = await handleSubmit(event, formData, setSubmissionMessage, setFieldErrors, investorType, token, selectedOrgId);
          
            if (result?.success) {
              setShowError(false); // ✅ Reset
              navigate('/success');
            } else {
              setShowError(true); // ✅ Trigger canvas error highlight
            }
          };   

    return (
        <div>
            <h1 className="center-text"><strong>HCRE 1177, LLC</strong></h1>
            <h2 className='center-text'>Subscription Agreement</h2>
            <h3 className="center-text">{today}</h3>

            <p>
            ⚠️ By submitting this form, you (the Subscriber) hereby represent and warrant that all the information contained in this form is accurate in all respects. If you received an error message suggesting that you are not a fit for this investment vehicle, please contact the sponsor. You agree to indemnify the sponsor and the Fund for any and all claims, damages, or liabilities related to any inaccurate information you supply using this form.
            </p>

            <h4>To get started, please select your investor type:</h4>

            <h4 style={{ marginLeft: '15px' }}>Select...</h4>

            <ul style={{ marginLeft: '35px' }}>
            <li>
                <strong>"Individual natural person"</strong> if the undersigned subscriber (the “Subscriber”) is a natural person.
            </li>
            <li>
                <strong>"Joint tenancy comprised solely of individual natural persons"</strong> if the Subscribers are a married couple subscribing as joint tenants.
            </li>
            <li>
                <strong>"Revocable grantor trust"</strong> the Subscriber is a revocable grantor trust, the sole settlor (i.e., grantor) of which is a natural person (or the sole settlors of which are a married couple).
            </li>
            <li>
                <strong>"Individual retirement account or self-directed employee benefit plan"</strong> if the Subscriber is an individual retirement account of a natural person or a self-directed employee benefit plan of a natural person.
            </li>
            <li>
                <strong>"Any other entity (including other trusts)"</strong> if the Subscriber is a corporation, partnership, limited liability company, a trust (other than a revocable grantor trust as detailed above) or other entity.
            </li>
            </ul>


            <select
            name="investorType"
            value={formData.investorType || ''}
            onChange={(event) => {
                const newType = event.target.value;
                setFormData({
                ...defaultFormData,
                investorType: newType
                });
            }}
            >
                <option value="">Select Investor Type</option>
                <option value="individual">Individual natural person</option>
                <option value="jointSpouse">Joint tenancy comprised soley of individual natural persons</option>
                <option value="revocableGrantorTrust">Revocable grantor trust</option>
                <option value="selfDirectedIRA">Individual retirement account or self-directed employee benefit plan</option>
                <option value="entity">Any other entity (including other trusts)</option>
            </select>

            {formData.investorType && (
            <div style={{ marginTop: '10px' }}>
                ⚠️ Your investor type selection will auto populate certain questions in the form below.
                You will be able to see these questions, but not modify the answers. If you think they are incorrect,
                please review your investor type selection.
            </div>
            )}


            <form onSubmit={onFormSubmit} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                    const type = e.target?.type;
                    const tag = e.target?.tagName?.toLowerCase();

                    // Allow multiline textareas and buttons
                    const allow = tag === "textarea" || type === "submit" || type === "button";
                    if (!allow) {
                        e.preventDefault();
                    }
                    }
                }}
            >
                {(isIndividual || isJointSpouse || isSelfDirectedIRA || isRevocableGrantorTrust) && (
                    <div>
                        <h1 className="center-text">Investor Qualification Statement for Individuals</h1>

                        <SubscriberInfo
                            formData={formData}
                            handleChange={(e) => handleChange(e, setFormData)}
                            setFormData={setFormData}
                        />

                        <br />
                        
                        <h2>Part I. Regulation D Matters.</h2>
                        <IndRegD formData={formData} handleChange={(e) => handleChange(e, setFormData)} fieldErrors={fieldErrors} />

                        <h2>Part II. Miscellaneous Matters. </h2>
                        <MiscellaneousMatters formData={formData} handleChange={(e) => handleChange(e, setFormData)} />
                    
                    <p>
                            The Subscriber hereby represents and warrants that all of the answers, statements and information set forth in this Investor Qualification Statement are true and correct on the date hereof and will be true and correct as of each date, if any, that the subscription set forth in the Subscription Agreement to which this Investor Qualification Statement relates is accepted, in whole or in part, by the General Partner.  The Subscriber hereby agrees to provide such additional information related to the foregoing as is requested by the General Partner and to notify the General Partner promptly of any change that may cause any answer, statement or information set forth in this Investor Qualification Statement to become untrue in any material respect.
                        </p>

                        <BankForm formData={formData} handleChange={(e) => handleChange(e, setFormData)} />
                                                
                        <br/>

                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '1px',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start'
                            }}>
                            <div style={{ flex: 1, minWidth: '300px' }}>
                                <SignaturePad
                                formData={formData}
                                setFormData={setFormData}
                                showError={showError}
                                />
                            </div>

                            <div style={{ flex: 1, minWidth: '300px' }}>
                                <SignaturePadSpouse
                                formData={formData}
                                setFormData={setFormData}
                                showError={showError}
                                />
                            </div>
                            </div>
                        <br/>
                        <br/>

                        <label>
                            <input type="checkbox" name="formAgreementChecked" checked={formData.formAgreementChecked} onChange={(e) => handleChange(e, setFormData)} required />
                            By submitting this form, you (the Subscriber) hereby represent and warrant that all the information contained in this form is accurate in all respects. If you received an error message suggesting that you are not a fit for this investment vehicle, please contact the sponsor. You agree to indemnify the sponsor and the Fund for any and all claims, damages, or liabilities related to any inaccurate information you supply using this form.
                        </label><br/>

                        <div>
                        <button type="submit" className="button-space">
                        Submit
                        </button>


                            <p>{submissionMessage}</p>

                        </div>
                    </div>
                )}
            </form>

            <form onSubmit={onFormSubmit} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                    const type = e.target?.type;
                    const tag = e.target?.tagName?.toLowerCase();

                    // Allow multiline textareas and buttons
                    const allow = tag === "textarea" || type === "submit" || type === "button";
                    if (!allow) {
                        e.preventDefault();
                    }
                    }
                }}
            >
                {isEntity && (
                    <div>
                        <h1 className="center-text">Investor Qualification Statement for Entities</h1>

                        <SubscriberInfo
                            formData={formData}
                            handleChange={(e) => handleChange(e, setFormData)}
                            setFormData={setFormData}
                        />

                        <br />

                        <h2>Part I. Regulation D Matters.</h2>
                        <EntityRegulationMatters formData={formData} handleChange={(e) => handleChange(e, setFormData)} fieldErrors={fieldErrors}  />

                        <h2> Part II. Miscellaneous Matters.</h2>
                        <EntityMiscMatters formData={formData} handleChange={(e) => handleChange(e, setFormData)} />

                        <p>
                            The Subscriber hereby represents and warrants that all of the answers, statements and information set forth in this Investor Qualification Statement are true and correct on the date hereof and will be true and correct as of each date, if any, that the subscription set forth in the Subscription Agreement to which this Investor Qualification Statement relates is accepted, in whole or in part, by the General Partner.  The Subscriber hereby agrees to provide such additional information related to the foregoing as is requested by the General Partner and to notify the General Partner promptly of any change that may cause any answer, statement or information set forth in this Investor Qualification Statement to become untrue in any material respect.
                        </p>

                        <EntityBankForm formData={formData} handleChange={(e) => handleChange(e, setFormData)} />
                        
                        <br/>

                        <SignaturePadEntity formData={formData} setFormData={setFormData} showError={showError} />

                        <br/>
                        <br/>

                        <label>
                            <input type="checkbox" name="entityFormAgreementChecked" checked={formData.entityFormAgreementChecked} onChange={(e) => handleChange(e, setFormData)} required/>
                            By submitting this form, you (the Subscriber) hereby represent and warrant that all the information contained in this form is accurate in all respects. If you received an error message suggesting that you are not a fit for this investment vehicle, please contact the sponsor. You agree to indemnify the sponsor and the Fund for any and all claims, damages, or liabilities related to any inaccurate information you supply using this form.
                        </label><br/>

                        <div>
                        <button type="submit" className="button-space">
                            Submit
                        </button>


                            <p>{submissionMessage}</p>

                        </div>
                    </div>
                )}
            </form>

        </div>
    );
}

export default RealEstateSPV_LLC;
